// extracted by mini-css-extract-plugin
module.exports = {"component":"toggle-component--3cyBw"};